import type { ReferencesMap } from '@fogia/core-web/utils/internalRefToSlug';

/**
 * Resolves a Sanity file or image asset URL from the page references map.
 * Use when you have an asset ref (e.g. from video.file.asset.ref or image.asset.ref)
 * and need the actual URL from page.data.references (populated via _references in GROQ).
 *
 * @param references - Map with asset ref keys and resolved objects that have a `url` property (ReferencesMap from page.data.references)
 * @param assetRef - Asset reference ID (e.g. "file-xxx-mp4", "image-xxx-jpg")
 * @returns The asset URL string, or undefined if not found or invalid
 */
export const getAssetUrlFromReferences = (references: ReferencesMap, assetRef: string): string | undefined => {
    if (!assetRef || typeof assetRef !== 'string' || assetRef.trim() === '') {
        return undefined;
    }
    const resolved = references[assetRef];
    const url =
        resolved && typeof resolved === 'object' && 'url' in resolved ? (resolved as { url?: string }).url : undefined;
    return typeof url === 'string' ? url : undefined;
};
